/* APIRoutes
* Use create/retrieve/update/delete keywords for api prop name and follow the module screen hierarchy.
* if same api is used for multiple operations, define it once with the prop name in short form
*  (e.g cu, cd,cud, crud)
*/

export const APIRoutes = {
    dashboardMaintenanceEnquiry: {
        hyperlinks: {
            retrieve: 'Hyperlinks/HyperlinkAction',
        },
        linesfilters: {
            retrieve: 'Filters/GetFilterOptionsList'
        },
        dashboardDetails: {
            new: 'ApplicationDashboardMaintenance/Dashboard/NewDashboard',
            retrieve: 'ApplicationDashboardMaintenance/Dashboard/:DashboardId',
            update: 'ApplicationDashboardMaintenance/Dashboard/:DashboardId',
            create: 'ApplicationDashboardMaintenance/Dashboard',
            delete: 'ApplicationDashboardMaintenance/Dashboard/:DashboardId'
        },
        quickLinks: {
            retrieve: 'ApplicationDashboardMaintenance/Dashboard/:DashboardId/QuickLinks',
            save: 'ApplicationDashboardMaintenance/Dashboard/:DashboardId/QuickLinks',
            dashboardType: {
                retrieve: 'ApplicationDashboardMaintenance/DashboardType/QuickLinks',
            },
        },
        widgets: {
            create: 'ApplicationDashboardMaintenance/Dashboard/:DashboardId/Widgets',
            retrieve: 'ApplicationDashboardMaintenance/Dashboard/:DashboardId/Widgets',
            delete: 'ApplicationDashboardMaintenance/Dashboard/:DashboardId/Widget/:DashboardWidgetId',
            reorder: 'ApplicationDashboardMaintenance/Dashboard/:DashboardId/ReorderWidgets',
            configuration: {
                retrieve: 'ApplicationDashboardMaintenance/DashboardType/Widget/:WidgetId/Fields',
                save: 'ApplicationDashboardMaintenance/Dashboard/Widget/:DashboardWidgetId/Fields',
                fieldList: {
                    retrieve: 'ApplicationDashboardMaintenance/Dashboard/Widget/:WidgetId/Fields'
                }
            }
        },
        enquiryProgram: {
            widgets: {
                retrieve: 'ApplicationDashboardMaintenance/Program/Dashboard/Widgets',
            }
        },
        customer: {
            dashboard: {
                OutstandingEnquiries: {
                    retrieve: 'ApplicationDashboardMaintenance/Dashboard/Widget/:DashboardWidgetId/Customer/:CustomerId/OutstandingEnquiries',
                },
                OutstandingQuotes: {
                    retrieve: 'ApplicationDashboardMaintenance/Dashboard/Widget/:DashboardWidgetId/Customer/:CustomerId/OutstandingQuotes',
                },
                PickSlips: {
                    retrieve: 'ApplicationDashboardMaintenance/Dashboard/Widget/:DashboardWidgetId/Customer/:CustomerId/PickSlips',
                },
            },
        },
        fields: {
            retrieve: 'ApplicationDashboardMaintenance/Dashboard/:DashboardId/FieldData',
        },
        alerts: {
            retrieve: 'ApplicationDashboardMaintenance/Dashboard/:DashboardId/AlertData',
        },
        inventory: {
            dashboard: {
                InventoryQuantities: {
                    retrieve: 'ApplicationDashboardMaintenance/Dashboard/Widget/:DashboardWidgetId/Product/:ProductId/InventoryQuantities',
                },
                OutstandingEnquiries: {
                    retrieve: 'ApplicationDashboardMaintenance/Dashboard/Widget/:DashboardWidgetId/Product/:ProductId/OutstandingEnquiries',
                },
                OutstandingQuotes: {
                    retrieve: 'ApplicationDashboardMaintenance/Dashboard/Widget/:DashboardWidgetId/Product/:ProductId/OutstandingQuotes',
                },
                PickSlips: {
                    retrieve: 'ApplicationDashboardMaintenance/Dashboard/Widget/:DashboardWidgetId/Product/:ProductId/PickSlips',
                },
            },
        },
    }
};
